export const UNIT_CATEGORY_FIELDS = [
  {
    id: "label",
    name: "label",
    label: "Label 🏷",
    type: "text",
    placeholder: "Enter category label",
  },
  {
    id: "shortDescription",
    name: "shortDescription",
    label: "Short Description 📝",
    type: "text",
    placeholder: "Write a short description here...",
  },
  {
    id: "mainDescription",
    name: "mainDescription",
    label: "Main Description 📝",
    type: "textarea",
    placeholder: "Enter main description",
  },
  {
    id: "description1",
    name: "description1",
    label: "Description 1 📝",
    type: "text",
    placeholder: "Enter description 1",
  },
  {
    id: "description2",
    name: "description2",
    label: "Description 2 📝",
    type: "text",
    placeholder: "Enter description 2",
  },
  {
    id: "description3",
    name: "description3",
    label: "Description 3 📝",
    type: "text",
    placeholder: "Enter description 3",
  },
  {
    id: "description4",
    name: "description4",
    label: "Description 4 📝",
    type: "text",
    placeholder: "Enter description 4",
  },
  {
    id: "bestFor",
    name: "bestFor",
    label: "Best For ⭐",
    type: "text",
    placeholder: "Enter what this category is best for",
  },
];

export const UNIT_CATEGORY_INITIAL_VALUES: Record<string, string> = {
  label: "",
  shortDescription: "",
  videoUrl: "",
  mainDescription: "",
  description1: "",
  description2: "",
  description3: "",
  description4: "",
  bestFor: "",
};
